import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getCardSetsThunk = createAsyncThunk(
  'cardSet/getCardSets',
  async ({ companyId }, { rejectWithValue }) => {
    try {
      return [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCardSetCategoriesThunk = createAsyncThunk(
  'cardSet/getCardSetCategories',
  async ({ companyId }, { rejectWithValue }) => {
    try {
      return [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCardSetDetailsThunk = createAsyncThunk(
  'cardSet/getCardSetDetails',
  async ({ cardSetId }, { rejectWithValue }) => {
    try {
      return {};
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCardSetCardsThunk = createAsyncThunk(
  'cardSet/getCardSetCards',
  async ({ cardSetId }, { rejectWithValue }) => {
    try {
      return [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const submitCardFeedbackThunk = createAsyncThunk(
  'cardSet/submitCardFeedback',
  async (
    { cardSetId, cardId, feedback, candidateCardSetId },
    { rejectWithValue }
  ) => {
    try {
      return { success: true };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const requestCardSetThunk = createAsyncThunk(
  'cardSet/requestCardSet',
  async ({ companyId, activityName }, { rejectWithValue }) => {
    try {
      return { success: true };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  list: [],
  selectedCardSet: null,
  cards: [],
  categories: [],
  loading: false,
  error: null,
  feedbackLoading: false,
  feedbackError: null,
};

const cardSetSlice = createSlice({
  name: 'cardSet',
  initialState,
  reducers: {
    setSelectedCardSet: (state, action) => {
      state.selectedCardSet = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearFeedbackError: (state) => {
      state.feedbackError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCardSetsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCardSetsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(getCardSetsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCardSetCategoriesThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCardSetCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(getCardSetCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCardSetDetailsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCardSetDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCardSet = action.payload;
      })
      .addCase(getCardSetDetailsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCardSetCardsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCardSetCardsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.cards = action.payload;
      })
      .addCase(getCardSetCardsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(submitCardFeedbackThunk.pending, (state) => {
        state.feedbackLoading = true;
        state.feedbackError = null;
      })
      .addCase(submitCardFeedbackThunk.fulfilled, (state) => {
        state.feedbackLoading = false;
      })
      .addCase(submitCardFeedbackThunk.rejected, (state, action) => {
        state.feedbackLoading = false;
        state.feedbackError = action.payload;
      })
      .addCase(requestCardSetThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(requestCardSetThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(requestCardSetThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedCardSet, clearError, clearFeedbackError } =
  cardSetSlice.actions;
export default cardSetSlice.reducer;
